import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import atomize from "@quarkly/atomize";
import { Box } from "@quarkly/widgets";
import StackItemContent from "./stackItemContent";
import { useOverrides } from "../hooks";
var overrides = {
  StackItemContent: {
    kind: "StackItemContent",
    props: {}
  }
};

var StackItem = function StackItem(_ref) {
  var gap = _ref.gap,
      props = _objectWithoutProperties(_ref, ["gap"]);

  var _useOverrides = useOverrides(props, overrides, {}),
      override = _useOverrides.override,
      children = _useOverrides.children,
      rest = _useOverrides.rest;

  return /*#__PURE__*/React.createElement(Box, _extends({}, rest, {
    "box-sizing": "border-box",
    padding: "calc(".concat(gap, " / 2)")
  }), /*#__PURE__*/React.createElement(StackItemContent, override('StackItemContent'), children));
};

StackItem.effects = {
  hover: ":hover"
};
export default Object.assign(StackItem, {
  overrides: overrides
});